module.exports = __webpack_public_path__ + "img/wow.482696ec.png";